import { isToolEnabled } from './user';
import {
  SideBarDashboardIcon,
  SideBarAcademyIcon,
  SideBarCopyrightIcon,
  SideBarBookIcon,
  SideBarLibraryIcon,
  SideBarCircolarityIcon,
  SideBarSurveyIcon,
  SideBarCertificationsIcon,
  SideBarAiIcon,
  SideBarDocumentsIcon,
  SideBarVideogalleryIcon,
} from 'assets/icons';
import SideBarBagIcon from 'assets/icons/SidebarIcon/SideBarBagIcon';
import * as PATHS from 'constants/paths';

export const navBarItem = [
  {
    label: 'Dashboard',
    path: PATHS.DASHBOARD,
    icon: SideBarDashboardIcon,
    ref: 'dashboard',
  },
  // Removed from the sidebar (still reachable from the dashboard widgets)
  // {
  //   label: 'Centro Studi',
  //   path: PATHS.STUDYCENTER,
  //   icon: SideBarChartIcon,
  //   ref: 'studyCenter',
  // },
  {
    label: 'Academy',
    path: PATHS.ACADEMY,
    icon: SideBarAcademyIcon,
    ref: 'academy',
  },
  // Removed from the sidebar (still reachable from the dashboard widgets)
  // {
  //   label: 'Finanza',
  //   path: PATHS.FINANCEANDTAX,
  //   icon: SideBarFinanceIcon,
  //   ref: 'finance',
  // },
  // {
  //   label: 'Biblioteca',
  //   path: PATHS.EDUCATION,
  //   icon: SideBarBookIcon,
  //   ref: 'library',
  // },
  {
    label: 'Libreria Materiali',
    path: PATHS.MATERIALLIBRARY,
    icon: SideBarLibraryIcon,
    ref: 'materialLibrary',
  },
  {
    label: 'Tool Circolarità',
    path: PATHS.CIRCULARITYTOOL,
    icon: SideBarCircolarityIcon,
    ref: 'circularityTool',
    // TODO: ACTIVE TOOL
    disabled: !isToolEnabled,
  },
  // Removed from the sidebar (still reachable from the dashboard widgets)
  // {
  //   label: 'Bosco del Design',
  //   path: PATHS.DESIGNWOODS,
  //   icon: SideBarTreesIcon,
  //   ref: 'designWood',
  // },
  {
    label: 'Survey Generale',
    path: PATHS.GENERALSURVEY,
    icon: SideBarSurveyIcon,
    ref: 'generalSurvey',
    disabled: true,
  },
  // Removed from the sidebar (still reachable from the dashboard widgets)
  // {
  //   label: 'Sportello Doganale',
  //   path: PATHS.CUSTOMHOUSEOFFICE,
  //   icon: SideBarSportelloIcon,
  //   ref: 'customHouseOffice',
  // },
  {
    label: 'Portale Certificazioni',
    path: PATHS.CERTIFICATION,
    icon: SideBarCertificationsIcon,
    ref: 'certifications',
  },
  {
    label: 'Borsa Italiana del Legno',
    path: PATHS.ITALIAN_WOOD_STOCK,
    icon: SideBarBagIcon,
    ref: 'italianWoodExchange',
  },
  // Not in the new sidebar design: kept after Borsa until confirmed
  {
    label: 'Proprietà Intellettuale',
    path: PATHS.INTELLECTUALPROPERTY,
    icon: SideBarCopyrightIcon,
    ref: 'intellectualProperty',
  },

  {
    label: 'Glossario',
    path: '/',
    icon: SideBarBookIcon,
    ref: 'glossary',
  },
];

// New sidebar items rendered after Glossario.
// TODO: destinations not defined yet, items are disabled until then.
export const extraNavBarItems = [
  {
    label: 'Documenti',
    path: '/',
    icon: SideBarDocumentsIcon,
    ref: 'documents',
    disabled: true,
  },
  {
    label: 'Videogallery',
    path: '/',
    icon: SideBarVideogalleryIcon,
    ref: 'videogallery',
    disabled: true,
  },
];

export const aiItems = [
  {
    label: 'Ai Concierge',
    path: '/',
    icon: SideBarAiIcon,
    ref: 'aiConcierge',
  },
];

export const HIGHLIGHT_COLOR = '#212B36'; // color/text/primary
